import script from "./PreviousActivitiesScorecardExpenses.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviousActivitiesScorecardExpenses.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});qInstall(script, 'directives', {ClosePopup});
